import React, { Component } from 'react';
import {DocumentLayout, PageWrapper} from '../../../components';
import { financials } from '../../../utils/api';
import {SummaryReportContainer} from "../../Admin/AuctionSummaryReportPage/components";

class AuctionSummaryReportExportPage extends Component {
  state = {
    data: null,
    loading: true
  };

  componentDidMount() {
    const queryStrings = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    const { auction_id, fromDate, toDate } = queryStrings;
    financials.fetchAuctionSummaryReport({auction_id: auction_id.split(','), fromDate, toDate}).then(({ data }) => {
      this.setState({
        data: data.data,
        loading: false
      });
    }).catch(({ response }) => {
      if (response.status === 404) {
        this.setState({
          loading: false
        });
      }
    });
  }

  render() {
    const { loading, data } = this.state;
    if (loading) return <DocumentLayout style={{padding: 20, width: 1200, height: 1400}}>Loading</DocumentLayout>;
    if (!data) return <DocumentLayout style={{padding: 20, width: 1200, height: 1400}}>Not Found</DocumentLayout>;
    return (
      <DocumentLayout style={{padding: 20, width: 1200, height: 1400}}>
        <PageWrapper>
          <SummaryReportContainer data={data} print />
        </PageWrapper>
      </DocumentLayout>
    );
  }
}

export default AuctionSummaryReportExportPage;
